<template>
  <span class="empty-move">...</span>
</template>

<script>
export default {
  name: "EmptyMove",
};
</script>

<style scoped>
.empty-move {
  padding: 0.125rem 0.25rem;
  color: #999;
  white-space: nowrap;
}
</style>
